import * as fieldset from './fieldset';

export default {
  title: 'Modifica Coupon Membership',
  elements: [
    {
      title: 'Main',
      type: 'editForm',
      config: {
        actions: {
          fetch: {
            endpoint: 'membership-coupons/{id}',
            method: 'GET',
            dataPath: 'data'
          },
          save: {
            endpoint: 'membership-coupons/{id}',
            method: 'PUT'
          }
        },
        fieldsets: [fieldset.main]
      }
    }
  ]
};
